// extracted by mini-css-extract-plugin
export default {"paymentPage":"ConfirmPayment_paymentPage__Es14u","confirmContainer":"ConfirmPayment_confirmContainer__lu5IS"};